import { ClearAllButton, DetailsSectionTitle, ItemChip, ItemsList } from './MaterialGradeModal.styles';

import { Box } from '../../../shared/styles/components/primitives.styles';
import React from 'react';
import { tokens } from '../../../shared/styles/core/tokens';

interface ItemListSectionProps {
    title: string;
    count: number;
    items: string[];
    type: 'affected' | 'excluded';
    onItemClick?: (itemNo: string) => void;
    onClearAll?: () => void;
    clickable?: boolean;
    showClearAll?: boolean;
}

export const ItemListSection: React.FC<ItemListSectionProps> = ({
    title,
    count,
    items,
    type,
    onItemClick,
    onClearAll,
    clickable = false,
    showClearAll = false
}) => (
    <Box m="lg" style={{
        borderTop: type !== 'affected' ? `${tokens.border.thin} ${tokens.neutral[3]}` : undefined,
        paddingTop: type !== 'affected' ? tokens.space.lg : undefined
    }}>
        <DetailsSectionTitle>
            <span>{title} ({count})</span>
            {showClearAll && onClearAll && (
                <ClearAllButton onClick={onClearAll} type="button">
                    Clear all
                </ClearAllButton>
            )}
        </DetailsSectionTitle>
        <ItemsList>
            {items.map((itemNo: string) => (
                <ItemChip
                    key={itemNo}
                    $type={type}
                    onClick={clickable ? () => onItemClick?.(itemNo) : undefined}
                    style={{
                        cursor: clickable ? 'pointer' : 'default',
                        opacity: type === 'excluded' && clickable ? 0.7 : type === 'excluded' ? 0.5 : 1
                    }}
                    title={clickable ? (type === 'affected' ? 'Click to exclude this item' : 'Click to include this item again') : undefined}
                >
                    {itemNo}
                </ItemChip>
            ))}
        </ItemsList>
    </Box>
);